import { Music, Video, Leaf, HelpCircle, Layers, PersonStanding, Heart, Sparkles, Footprints, Compass, Timer, FileText } from "lucide-react";

// Universal method-kind catalog — mirrors the mobile builder (coach_methods.py KIND_WHITELIST).
export const KIND_META = [
  { key: "audio", icon: Music, tone: "brand" },
  { key: "video", icon: Video, tone: "brand" },
  { key: "breathwork", icon: Leaf, tone: "brand" },
  { key: "questions", icon: HelpCircle, tone: "accent" },
  { key: "combo", icon: Layers, tone: "accent" },
  { key: "body_scan", icon: PersonStanding, tone: "muted" },
  { key: "gratitude", icon: Heart, tone: "muted" },
  { key: "visualization", icon: Sparkles, tone: "muted" },
  { key: "movement", icon: Footprints, tone: "muted" },
  { key: "check_in", icon: Compass, tone: "muted" },
];

export const KIND_ICON = Object.fromEntries(KIND_META.map((m) => [m.key, m.icon]));

export const STEP_KINDS = ["breathwork", "audio", "video", "body_scan", "gratitude", "visualization", "movement", "questions", "check_in", "timer", "text"];
export const STEP_ICON = { ...KIND_ICON, timer: Timer, text: FileText };

export const VISIBILITIES = ["private", "shared_with_clients", "public"];

export function kindIcon(k) {
  return KIND_ICON[k] || Layers;
}
